import { Link } from 'react-router-dom';

const trustChips = [
  { icon: 'ri-shield-check-fill', label: 'Licensed & Insured' },
  { icon: 'ri-award-fill', label: '20+ Years Experience' },
  { icon: 'ri-file-check-fill', label: 'Code-Compliant Work' },
  { icon: 'ri-heart-fill', label: 'Faith-Based Company' },
  { icon: 'ri-team-fill', label: 'Employee-Owned' },
];

const AboutHero = () => (
  <section className="relative w-full min-h-[88vh] flex items-center overflow-hidden">
    {/* Background image */}
    <div className="absolute inset-0">
      <img
        src="https://public.readdy.ai/ai/img_res/6564f5e7e9935663f71662485ae5b3d9.jpg"
        alt="DOC Electric team at work"
        className="w-full h-full object-cover object-top"
      />
    </div>

    {/* Gradient overlays */}
    <div className="absolute inset-0 bg-gradient-to-r from-[#060E1C]/95 via-[#0A1628]/80 to-[#060E1C]/50" />
    <div className="absolute inset-0 bg-gradient-to-t from-[#060E1C]/80 via-transparent to-[#060E1C]/40" />

    {/* Subtle electric glow bottom */}
    <div className="absolute bottom-0 left-0 right-0 h-[1px] bg-gradient-to-r from-transparent via-[#00D9FF]/30 to-transparent" />

    <div className="relative w-full max-w-7xl mx-auto px-6 lg:px-10 pt-36 pb-24">
      <div className="max-w-3xl">
        {/* Label */}
        <div className="flex items-center gap-3 mb-7">
          <span className="h-[1px] w-10 bg-[#00D9FF]" />
          <span className="text-[#00D9FF] text-[11px] font-bold tracking-[3px] uppercase">
            About DOC Electric LLC
          </span>
        </div>

        {/* Headline */}
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-black text-white leading-[1.05] tracking-tight mb-6">
          Built on{' '}
          <span className="relative inline-block">
            Integrity.
            <span className="absolute -bottom-1 left-0 right-0 h-[3px] bg-[#00D9FF] rounded-full opacity-80" />
          </span>
          <br />
          <span className="text-white/90">Wired for</span>{' '}
          <span className="text-[#00D9FF]">Excellence.</span>
        </h1>

        {/* Subtext */}
        <p className="text-white/80 text-lg md:text-xl leading-relaxed mb-10 max-w-xl">
          Kalamazoo&apos;s trusted electrical contractor — faith-based, employee-owned,
          and backed by 20+ years of honest, high-quality work in homes and buildings across southwest Michigan.
        </p>

        {/* CTAs */}
        <div className="flex flex-wrap items-center gap-4">
          <a
            href="#estimate"
            className="px-8 py-4 bg-[#00D9FF] hover:bg-[#00c5e8] text-[#0A1628] font-black text-[13px] uppercase tracking-wider rounded-lg transition-all duration-300 hover:shadow-[0_0_32px_rgba(0,217,255,0.5)] hover:-translate-y-0.5 cursor-pointer whitespace-nowrap"
          >
            Request a Free Estimate
          </a>
          <a
            href="tel:+12693700765"
            className="flex items-center gap-3 px-6 py-4 border border-white/20 hover:border-[#00D9FF]/50 rounded-lg text-white/80 hover:text-white text-[13px] font-medium transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-phone-fill text-[#00D9FF]" />
            </span>
            (269) 370-0765
          </a>
        </div>

        {/* Trust chips */}
        <div className="mt-12 flex flex-wrap items-center gap-3">
          {trustChips.map((chip) => (
            <div
              key={chip.label}
              className="flex items-center gap-2 px-4 py-2 rounded-full border border-white/10 bg-white/5 backdrop-blur-sm"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className={`${chip.icon} text-[#00D9FF] text-xs`} />
              </span>
              <span className="text-white/75 text-[12px] font-medium whitespace-nowrap">{chip.label}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default AboutHero;
